import Arrow from '../../assets/Arrow';
import { type OffersSlimVariant } from '../../utils/variants';

import containerVariant, { wrapper } from './styles';
import { useScrollState } from './useScrollState';

export interface ContainerProps {
  uncappedOfferDisplay?: boolean;
  variant: OffersSlimVariant;
}

const readCSSNumberValue = (el: HTMLElement, prop: string) =>
  Number(window.getComputedStyle(el, null).getPropertyValue(prop).replace('px', ''));

export const Container: React.FC<React.PropsWithChildren<ContainerProps>> = ({
  children,
  uncappedOfferDisplay,
  variant = 'default',
}) => {
  const classname = containerVariant(variant);
  const { canScrollLeft, canScrollRight, containerRef, wrapperRef } = useScrollState();

  const triggerScroll = (forward?: boolean) => {
    if (containerRef.current) {
      const root = containerRef.current;
      const gap = readCSSNumberValue(root, 'column-gap');
      const offerWidth = (root.children[0] as HTMLDivElement).offsetWidth;
      const diff = offerWidth + gap;

      if (forward) {
        root.scrollLeft += diff;
      } else {
        root.scrollLeft -= diff;
      }
    }
  };

  return (
    <div className={wrapper} ref={wrapperRef}>
      <div className={classname} data-uncapped={uncappedOfferDisplay || undefined} ref={containerRef}>
        {children}
      </div>
      <button
        aria-label="Scroll Left"
        onClick={() => triggerScroll()}
        style={{ display: canScrollLeft ? 'flex' : 'none' }}
      >
        <Arrow />
      </button>
      <button
        aria-label="Scroll Right"
        onClick={() => triggerScroll(true)}
        style={{ display: canScrollRight ? 'flex' : 'none' }}
      >
        <Arrow />
      </button>
    </div>
  );
};
